<template>
  <div class="checkout-cart">
    <checkout-cart-item
        v-for="(cartItem, pIdx) in this.cartData.products"
        :key="cartItem.id"
        v-model="this.cartData.products[pIdx]"
        @update="updateCartQuantity"
        @remove="removeCartItem"/>
<!--    <checkout-cart-item-->
<!--      v-for="(cartItem, pIdx) in processedProducts"-->
<!--      :key="cartItem.id"-->
<!--      v-model="processedProducts[pIdx]"-->
<!--      @update="updateCartQuantity"-->
<!--      @remove="removeCartItem"/>-->
    <div class="cart-modal__purchases-clear text" @click="onClear">
      הסר הכל
    </div>
  </div>
</template>

<script>
import CheckoutCartItem from './checkout-cart-item'

export default {
  name: "CheckoutCart",
  components: {
    CheckoutCartItem
  },
  props: {
    cartData: Object
  },
  computed: {},
  data() {
    return {
      // processedProducts: [] // Локальная копия обработанных продуктов
    }
  },
  mounted() {
    // Обрабатываем данные при первой загрузке
    // const localProducts = this.cartData.products;
    // const sale = this.processCartData(localProducts);
    // const updatedProducts = this.updateProductsBasedOnSale(localProducts, sale);
    // this.processedProducts = updatedProducts;
    // this.processedProducts = cartData.products;
    // const sale = this.processCartData(this.cartData.products);
  },
  methods: {

    // processCartData(products) {
    //   console.log('products',products)
    //
    //   const sale = [];
    //   const categoryMap = new Map();
    //
    //   products.forEach(item => {
    //     item.discount = 0;
    //     if (item.is_sale) {
    //       const category = item.category_sale;
    //       if (!categoryMap.has(category)) {
    //         categoryMap.set(category,[]);
    //       }
    //       // variant 1 - one product in the category
    //       // categoryMap.get(category).push({
    //       //   product_id: item.product_id,
    //       //   price: item.price,
    //       //   sum_sale: item.sum_sale
    //       // });
    //
    //       // variant 2 - every second product in the category
    //       for (let i = 0; i < item.quantity; i++) {
    //         categoryMap.get(category).push({
    //           product_id: item.product_id,
    //           price: item.price,
    //           sum_sale: item.sum_sale
    //         });
    //       }
    //     }
    //   });
    //
    //   categoryMap.forEach((productsInCategory, category) => {
    //     if (productsInCategory.length >= 2) {
    //       // variant 1 - one product in the category
    //       // const minPriceProduct = productsInCategory.reduce((min, current) => {
    //       //   return current.price < min.price ? current : min;
    //       // }, productsInCategory[0]);
    //       // sale.push(minPriceProduct);
    //
    //       // variant 2 - every second product in the category
    //       productsInCategory.sort((a, b) => a.price - b.price);
    //       // productsInCategory.reduce((min, current) => {
    //       //   return current.price < min.price ? current : min;
    //       // });
    //
    //       let count = productsInCategory.length;
    //       let index = Math.floor(count/2);
    //       for (let i = 0; i < index; i++) {
    //         sale.push(productsInCategory[i]);
    //       }
    //     }
    //   });
    //
    //   return sale;
    // },
    //
    // updateProductsBasedOnSale(localProducts, sale) {
    //   // variant 1 - one product in the category
    //   // const saleIds = sale.map(item => item.product_id);
    //   // //const updatedProductIds = []; // Массив для хранения ID обновленных продуктов
    //   //
    //   // localProducts.forEach(product => {
    //   //   if (saleIds.includes(product.product_id)) { // && !updatedProductIds.includes(product.product_id)) {
    //   //     //console.log(product);
    //   //     //product.line_price -= product.price * (product.sum_sale/100);
    //   //     //updatedProductIds.push(product.product_id); // Добавляем ID продукта в массив обновленных
    //   //   }
    //   //   else {
    //   //     product.is_sale = 0;
    //   //     product.sum_sale = 0;
    //   //   }
    //   // });
    //
    //   // variant 2 - every second product in the category
    //   if (sale.length > 0) {
    //     sale.sort((a, b) => a.product_id - b.product_id);
    //     const sumSale = [];
    //     for (let i = 0; i < sale.length; i++) {
    //       const currentProductId = sale[i].product_id;
    //       const productIndex = localProducts.findIndex(item => item.product_id === currentProductId);
    //       if (productIndex !== -1) {
    //         localProducts[productIndex].discount += (sale[i].price * (sale[i].sum_sale/100))
    //       }
    //     }
    //   }
    //
    //   return localProducts;
    // },

    removeCartItem(data) {
      dataLayer = dataLayer || [];
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "remove_from_cart",
        ecommerce: {
          items: [{
            item_name: data.item.name,
            item_id: data.item.article,
            price: data.item.line_price,
            item_brand: "Babolat",
            item_category: data.item.category,
            quantity: data.item.quantity
          }]
        }
      });

      Cart.remove({id: data.item.id})

      // this.processedProducts = [];
      // Cart.remove({ id: data.item.id })
      //   .then(resp => {
      //     if (resp.data.success) {
      //       const products = resp.data.cartData.products;
      //       products.forEach(product => {
      //         this.processedProducts.push(product);
      //       });
      //       this.$nextTick(() => {
      //         // console.log('Итоговый this.processedProducts:', this.processedProducts);
      //         const sale = this.processCartData(this.processedProducts);
      //         // console.log(sale)
      //         this.processedProducts = this.updateProductsBasedOnSale(this.processedProducts, sale);
      //       });
      //     }
      //   })
    },

    onClear() {
      let cartItems = [];
      this.cartData.products.forEach((item) => {
        cartItems.push({
          item_name: item.name,
          item_id: item.article,
          price: item.line_price,
          item_brand: "Babolat",
          item_category: item.category,
          quantity: item.quantity
        })
      })
      dataLayer = dataLayer || [];
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "remove_from_cart",
        ecommerce: {
          items: cartItems
        }
      });
      Cart.clear();
      window.location.reload();
    },

    updateCartQuantity(data) {
      if (data.item.quantity > 0) {
        if(data.quantity === -1) {
          dataLayer = dataLayer || [];
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: "remove_from_cart",
            ecommerce: {
              items: [{
                item_name: data.item.name,
                item_id: data.item.article,
                price: data.item.line_price,
                item_brand: "Babolat",
                item_category: data.item.category,
                quantity: 1
              }]
            }
          });
        } else {
          dataLayer = dataLayer || [];
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
              items: [{
                item_name: data.item.name,
                item_id: data.item.article,
                price: data.item.line_price,
                item_brand: "Babolat",
                item_category: data.item.category,
                quantity: 1
              }]
            }
          });
        }
        if(data.item.quantity < 99) {
          Cart.update({id: data.item.id, quantity: data.quantity})

          // this.processedProducts.forEach(product => {
          //   if (product.id == data.item.id) {
          //     product.quantity += data.quantity
          //   }
          // });
          // const sale = this.processCartData(this.processedProducts);
          // this.processedProducts = this.updateProductsBasedOnSale(this.processedProducts, sale);

        }
      } else if (data.item.quantity === 0 && data.quantity < 0) {
        Cart.getItems()
      } else {
        Cart.add(data.item.variant_id)
      }
    },
  }
}
</script>

<style scoped>

</style>
